export const BU_BUTTON_COLORS = [
  'white',
  'light',
  'dark',
  'black',
  'text',
  'primary',
  'link',
  'info',
  'success',
  'warning',
  'danger'
];

export const BU_BUTTON_SIZES = [
  'small',
  'medium',
  'large'
];

export const BU_BUTTON_STATES = [
  'hovered',
  'focused',
  'active',
  'loading',
  'static'
];
